import environment from "./environment";
import pages from "./pages";
import run from "./run";
import workflow from "./workflow";

export default { ...pages, environment, run, workflow };
